import { render, staticRenderFns } from "./checkout-address-new-inputs.vue?vue&type=template&id=5cdb12ab&"
import script from "./checkout-address-new-inputs.vue?vue&type=script&lang=js&"
export * from "./checkout-address-new-inputs.vue?vue&type=script&lang=js&"
import style0 from "./checkout-address-new-inputs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports